import React from "react";
import { Outlet } from 'react-router-dom';
import UserRoles from '../../../hooks/userRoles';
import AdminHeader from "../../AdminPortal/Header/AdminHeader";
import AdminSidebar from "../Sidebar/AdminSidebar";
import Footer from '../../AdminPortal/Footer/Footer';

const AdminLayout = () => {
  return (
    <div className="wrapper">
      <AdminHeader />
      <AdminSidebar allowedRoles={UserRoles} />
      <div className="content-wrapper">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default AdminLayout;
